import axios from 'axios';

import { FetchStatus } from '@powdr/constants';
import { getNodeApiDomain } from '@powdr/utils';

import { LIFTS_PENDING, LIFTS_SUCCESS, LIFTS_ERROR } from '../types';

export const getLifts = () => async (dispatch, getState) => {
  const liftsStatus = getState().lifts.status;

  // If more than one component calls the same feed make sure we only make one request
  if (liftsStatus !== FetchStatus.LOADING && liftsStatus !== FetchStatus.PENDING) {
    try {
      dispatch({
        type: LIFTS_PENDING,
        payload: [],
      });
      const res = await axios.get(`${getNodeApiDomain()}/dor/drupal/lifts`);
      dispatch({
        type: LIFTS_SUCCESS,
        payload: res.data,
      });
    } catch (error) {
      dispatch({
        type: LIFTS_ERROR,
        payload: error,
      });
    }
  }
};
